import script from "./TypeAheadMultiSelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeAheadMultiSelectBox.vue?vue&type=script&setup=true&lang=js"

import "./TypeAheadMultiSelectBox.vue?vue&type=style&index=0&id=ba99ff76&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba99ff76"]])

export default __exports__